export default "__VITE_ASSET__BLT1C_GM__"